<script setup lang="ts">
import {Icon} from '@iconify/vue';
import {storeToRefs} from "pinia";
import {useTabStore} from "@/stores/useTabStore.ts";
import {BUILD_ID_ISO, BUILD_ID_LABEL} from "@/shared/buildInfo";


const emit = defineEmits<{
  (e: 'help'): void;
}>();
const {mainTabs: tabs, activeMainTab: activeTab} = storeToRefs(useTabStore())

</script>

<template>
  <header class="shrink-0 z-30 border-b border-gray-200/80 bg-white/95 backdrop-blur">
    <!-- Mittlere Spalte `auto`: die Tab-Leiste bekommt ihre volle Breite und bleibt zentriert; Logo
         und Aktionen teilen sich den Rest (bei gleichen Dritteln wurden die Tab-Labels abgeschnitten). -->
    <div class="mx-auto grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-4 px-4 py-2 sm:px-6 lg:px-8">
      <div class="flex w-full min-w-0 items-center gap-3">
        <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600 ring-1 ring-blue-100">
          <Icon icon="fa6-solid:music" class="text-base"/>
        </div>
        <div class="min-w-0">
          <h1 class="truncate text-base font-bold text-gray-900 sm:text-lg">Griffschrift Converter</h1>
          <p class="hidden truncate text-xs text-gray-500 lg:block">für Steirische Harmonika</p>
        </div>
      </div>

      <div class="flex justify-center">
        <nav class="flex  gap-1 rounded-xl border border-gray-200 bg-gray-100 p-1" aria-label="Bereiche">
          <button
              v-for="tab in tabs"
              :key="tab.id"
              type="button"
              class="flex min-w-0 items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold transition-colors duration-200 outline-none focus-visible:ring-2 focus-visible:ring-blue-500/50"
              :class="activeTab === tab.id
              ? 'bg-white text-blue-700 shadow-sm ring-1 ring-black/5'
              : 'text-gray-600 hover:bg-white/70 hover:text-gray-900'"
              @click="activeTab = tab.id"
              :aria-label="tab.label"
              :aria-current="activeTab === tab.id ? 'page' : undefined"
              :title="tab.label"
          >
            <Icon :icon="tab.icon" class="shrink-0" :class="activeTab === tab.id ? 'text-blue-500' : 'text-gray-400'"/>
            <span class="hidden truncate md:inline">{{ tab.label }}</span>
          </button>
        </nav>
      </div>

      <div class="flex items-center justify-end gap-1">

        <button
            type="button"
            class="btn btn-ghost !px-2 !py-2 shrink-0"
            aria-label="Hilfe"
            title="Hilfe"
            @click="emit('help')"
        >
          <Icon icon="fa6-solid:circle-question" class="text-base"/>
        </button>
        <span
            class="hidden sm:inline mr-1 text-[10px] font-mono tabular-nums text-gray-400 select-none"
            :title="`Build ${BUILD_ID_ISO}`"
            :aria-label="`Build ${BUILD_ID_LABEL}`"
        >{{ BUILD_ID_LABEL }}</span>
      </div>
    </div>
  </header>
</template>

<style>
@plugin "@iconify/tailwind4";
</style>
